import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

const Notices = () => {
  const { getAuthHeaders } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const headers = getAuthHeaders();
      const res = await fetch('/api/zpost/notifications?limit=100', { headers });
      const data = await res.json();
      if (data.success) {
        setNotifications(data.notifications);
      } else {
        setError('Failed to load notifications');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      const headers = getAuthHeaders();
      await fetch(`/api/zpost/notifications/${id}/read`, { method: 'PUT', headers });
      setNotifications(prev =>
        prev.map(n => (n.id === id ? { ...n, is_read: true } : n))
      );
    } catch (err) {
      console.error('Failed to mark read', err);
    }
  };

  const markAllAsRead = async () => {
    try {
      const headers = getAuthHeaders();
      await fetch('/api/zpost/notifications/read-all', { method: 'PUT', headers });
      setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
    } catch (err) {
      console.error('Failed to mark all read', err);
    }
  };

  const getMessage = (notif) => {
    const actor = notif.actor_ens;
    switch (notif.type) {
      case 'like':
        return (
          <span>
            <strong>{actor}</strong> liked your{' '}
            <Link to={`/post/${notif.post_id}`}>post</Link>
          </span>
        );
      case 'repost':
        return (
          <span>
            <strong>{actor}</strong> reposted your{' '}
            <Link to={`/post/${notif.post_id}`}>post</Link>
          </span>
        );
      case 'follow':
        return (
          <span>
            <strong>{actor}</strong> started following you
          </span>
        );
      case 'comment':
        return (
          <span>
            <strong>{actor}</strong> commented on your{' '}
            <Link to={`/post/${notif.post_id}`}>post</Link>
          </span>
        );
      default:
        return null;
    }
  };

  if (loading) return <div className="loading">Loading notices...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="notices-page" style={{ padding: '16px' }}>
      <h2 style={{ marginTop: 0, marginBottom: '1.5rem' }}>Notices</h2>
      {notifications.length > 0 && (
        <button
          onClick={markAllAsRead}
          className="btn btn-gold"
          style={{ marginBottom: '1.5rem' }}
        >
          Mark all as read
        </button>
      )}
      {notifications.length === 0 ? (
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>
          No notices yet
        </p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {notifications.map(notif => (
            <li
              key={notif.id}
              style={{
                marginBottom: '1rem',
                padding: '1rem',
                borderRadius: '8px',
                backgroundColor: notif.is_read ? 'transparent' : 'rgba(255, 215, 0, 0.05)',
                border: notif.is_read ? '1px solid var(--border)' : '1px solid var(--gold)',
                cursor: notif.is_read ? 'default' : 'pointer',
                transition: 'all 0.2s ease',
              }}
              onClick={() => !notif.is_read && markAsRead(notif.id)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ color: 'var(--text-light)' }}>{getMessage(notif)}</div>
                <span
                  className="time"
                  style={{
                    color: 'var(--text-secondary)',
                    fontSize: '0.8rem',
                    marginLeft: '1rem',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {formatDistanceToNow(new Date(notif.created_at))} ago
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notices;
